import React from "react";
import "./NoResults.scss";

export const NoResults = ({ label, height }) => (
    <div className="NoResults" style={height ? { minHeight: height } : {}}>
        <div>{label ? label : "No results"}</div>
    </div>
);
